<template>
  <article>
    <div>
			<span class="xbed-sub-title">卡券使用记录</span>
		</div>
		<div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>营销管理</BreadcrumbItem>
				<BreadcrumbItem>卡券使用记录</BreadcrumbItem>
			</Breadcrumb>
		</div>
		<br>
    <Form @submit.native.prevent="preventSubmit" inline>
      <FormItem label="卡券ID:" prop="cardId" :label-width="100">
				<Input type="text" v-model.trim="queryKeyWords.cardId" style="width:200px"></Input>
			</FormItem>
      <FormItem label="订单号:" prop="orderNo" :label-width="100">
				<Input type="text" v-model.trim="queryKeyWords.orderNo" style="width:200px"></Input>
			</FormItem>
      <FormItem label='状态:' :label-width='100'>
				<Select v-model="queryKeyWords.stat" filterable>
					<Option :value="-1">全部</Option>
					<Option :value="1">进行中</Option>
					<Option :value="2">完成使用</Option>
					<Option :value="3">过期失效</Option>
				</Select>
			</FormItem>
      <FormItem label='是否锁定:' :label-width='100'>
				<Select v-model="queryKeyWords.lockCard" filterable>
					<Option :value="-1">全部</Option>
					<Option :value="0">未锁定</Option>
					<Option :value="1">锁定</Option>
				</Select>
			</FormItem>
      <FormItem>
        <Button type="primary" @click="changeQueryKeyWord">查询</Button>
      </FormItem>
    </Form>
    <Content>
      <Table stripe :columns="columnsList" :data='dataList' :loading='cardListLoading'></Table>
      <div style="margin: 10px;overflow: hidden">
				<Page show-sizer :page-size="queryKeyWords.size" :current="queryKeyWords.page" :total="listTotal" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
			</div>
    </Content>
  </article>
</template>
<script>
import Moment from "moment";
import API from "@/api";
import Utils from "../../utils";
export default {
  created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
	},
  data(){
    return{
      // 查询关键字
      queryKeyWords:{
        url:'/api/couponCard/record',
        cardId:'',
        orderNo:'',
        stat:-1,
        lockCard:-1,
        size:10,
        page:1,
      },
      // query:{
      //   url:'/api/couponCard/record',
      //   cardId:'',
      //   orderNo:'',
      //   stat:-1,
      //   lockCard:-1,
      //   size:10,
      //   page:1,
      // },
      listTotal:0,
      cardListLoading:false,
      dataList:[],
      columnsList:[
        {
          title:'自增ID',
          key:'recordId',
          align:'center',
          width:150,
          sortable: true
        },
        {
          title:'卡券ID',
          key:'cardId',
          align:'center',
          width:230,
          sortable: true
        },
        {
          title:'卡券Code',
          key:'code',
          align:'center',
          width:200,
          sortable: true
        },
        {
          title:'状态',
          key:'stat',
          align:'center',
          width:120,
          sortable: true,
          render: ( h, params ) => {
            const status = [ "","进行中", "完成使用","过期失效"][params.row.stat];
            const statusColor = ["", "green","yellow","red"][params.row.stat];
            return h( "Tag", {
              props:{
                color:statusColor
              }
            }, status );
          }
        },
        {
          title:'是否锁定',
          key:'lockCard',
          align:'center',
          width:150,
          sortable: true,
          render:(h,params) =>{
            const status = ['未锁定','锁定'][params.row.lockCard];
            const statusColor = ['green','yellow'][params.row.lockCard];
            return h('Tag',{
              props:{
                color:statusColor
              }
            },status)
          }
        },
        {
          title:'订单号',
          key:'orderNo',
          align:'center',
          width:230,
          sortable: true
        },
        {
          title:'可预订时间',
          key:'useDatetime',
          align:'center',
          width:200,
          sortable: true,
          render: ( h, param ) => {
						return h(
							"span",
							param.row.useDatetime ? Moment( param.row.useDatetime ).format( "YYYY-MM-DD HH:mm:ss" ) : ''
						);
					}
        },
        {
          title:'周末可用',
          key:'otherUse',
          align:'center',
          width:150,
          sortable: true,
          render:(h,params) =>{
            if (this.listTotal != 0) {
              const str = params.row.otherUse
              const reg = RegExp(/weekend/)
              const result = reg.test(str) ? '否' : '是'
              return h('span',{},result)
            }
          }
        },
      ]
    }
  },
  mounted () {
    this.$Notice.config( {
			top: 200
		} );
    this.queryCouponCardUsedRecord()
  },
  methods: {
    //查询卡券使用记录
    async queryCouponCardUsedRecord() {
      if ( !Utils.hasPermission( 'couponCard_record_list' ) ) {
        this.$Notice.error( {
          title: "无权限操作"
        } );
        return
      }
      this.cardListLoading = true
      let params = {
        url:this.queryKeyWords.url,
        cardId:this.queryKeyWords.cardId,
        orderNo:this.queryKeyWords.orderNo,
        stat:this.queryKeyWords.stat,
        lockCard:this.queryKeyWords.lockCard,
        size:this.queryKeyWords.size,
        page:this.queryKeyWords.page - 1,
      }
      let resp = (await API.omsAPI[this.env].marketing.CouponCard('GET',params, this.token)).data;
      this.cardListLoading = false
      if ( resp.retCode ) {
				this.$Notice.error({
					title: '卡券使用记录数据异常',
					desc: resp.msg
				})
				return
      }
      this.dataList = resp.content
      this.listTotal = resp.total
    },
    // 查询关键字
    changeQueryKeyWord(){
      this.queryKeyWords.page = 1
      this.queryCouponCardUsedRecord()
    },
    changePageSize(pageSize){
      this.queryKeyWords.page = 1
      this.queryKeyWords.size = pageSize
      this.queryCouponCardUsedRecord()
    },
    changePage(page){
      this.queryKeyWords.page = page
      this.queryCouponCardUsedRecord()
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/pages/marketing/couponCardUsedRecord.vue